import { useAuthStore } from '@/store/useAuthStore';
import UserManagementPanel from '@/components/Dashboard/UserManagementPanel';

const UserManagementPage = () => {
  const { accessLevel } = useAuthStore();

  if (accessLevel !== 'SUPER_ADMIN') {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <h2 className="text-xl font-bold text-gray-900">User Management</h2>
        <p className="mt-2 text-sm text-gray-600">
          Only super admins can manage user access.
        </p>
      </div>
    );
  }

  return <UserManagementPanel />;
};

export default UserManagementPage;
